module.exports = __webpack_public_path__ + "static/media/ashmore-ellis-loop-1.547f72c6.jpg";